import styled from "styled-components";
import { device } from "../../../../style/styled-components/helpers/device";
// 통관 구분 한 칸: 구분선(기준 금액 축) 아래 구분 이름과 대상 목록.
// 예전의 #66c 화살표·점선 박스 장식은 걷어내고 타이포와 점 목록으로만 보여 준다.
const ExpressUnderstandingType = ({ type, contents }) => {
  return (
    <Div>
      <div className="type">{type}</div>
      <ul className="list">
        {contents?.map((x, idx) => {
          return <li key={idx}>{x}</li>;
        })}
      </ul>
    </Div>
  );
};
export default ExpressUnderstandingType;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.colors.monotone.light};
  padding-top: 1.75em;
  & > div.type {
    font-size: 1.1em;
    @media ${device.mobileL} {
      font-size: 1.3em;
    }
    @media ${device.tablet} {
      font-size: 1.5em;
    }
    font-weight: 800;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.colors.dark};
  }
  & > ul.list {
    list-style: none;
    margin: 0.9em 0 0;
    padding: 0 0.75em;
    display: flex;
    flex-direction: column;
    gap: 0.35em;
    color: ${({ theme }) => theme.colors.foreground.dimmed};
    font-size: max(0.8em, 1.8vw);
    @media ${device.tablet} {
      font-size: min(1.65vw, 1em);
    }
    @media ${device.laptopL} {
      font-size: 1.1em;
    }
    & > li {
      position: relative;
      padding-left: 0.8em;
      line-height: 1.5;
      &::before {
        content: "•";
        position: absolute;
        left: 0;
        color: ${({ theme }) => theme.colors.accent};
      }
    }
  }
`;
